const LICENSES = {
  "states": [
    {
      "state": "Alabama",
      "type": "Business Entity Producer: Accident & Health or Sickness; Property; Casualty",
      "number": "754518"
    },
    {
      "state": "Arkansas",
      "type": "Producer: Accident, Health & Sickness; Property; Casualty",
      "number": "100150191"
    },
    {
      "state": "Arizona",
      "type": "Insurance Professional: Producer, Casualty; Producer, Accident/Health/Sickness; Producer, Property",
      "number": "1142531"
    },
    {
      "state": "California",
      "type": "Resident Insurance Producer: Property Broker-Agent; Casualty Broker-Agent; Accident and Health Agent",
      "number": "0K71084"
    },
    {
      "state": "Colorado",
      "type": "Producer: Property; Casualty; Accident and Health",
      "number": "503900"
    },
    {
      "state": "Connecticut",
      "type": "Producer: Accident & Health; Travel Accident & Baggage; Credit Products; Casualty; Property",
      "number": "2519755"
    },
    {
      "state": "District of Columbia",
      "type": "Producer: Accident & Health or Sickness; Property; Casualty; Personal Lines",
      "number": "3090332"
    },
    {
      "state": "Delaware",
      "type": "Producer",
      "number": "1403785"
    },
    {
      "state": "Hawaii",
      "type": "Producer: Casualty; Life; Accident & Health or Sickness; Marine; Property; Surety; Vehicle",
      "number": "438197"
    },
    {
      "state": "Iowa",
      "type": "Business Entity Producer",
      "number": "1002268796"
    },
    {
      "state": "Idaho",
      "type": "Non-Resident Producer: Casualty; Property; Disability (Health)",
      "number": "567073"
    },
    {
      "state": "Illinois",
      "type": "Business Entity Producer",
      "number": "100760721"
    },
    {
      "state": "Indiana",
      "type": "Producer - Organization (Corp): Accident & Health; Property & Casualty",
      "number": "3147204"
    },
    {
      "state": "Kansas",
      "type": "Agency",
      "number": "352533139"
    },
    {
      "state": "Louisiana",
      "type": "Producer Agency: Accident & Health; Property; Casualty",
      "number": "688862"
    },
    {
      "state": "Maryland",
      "type": "Producer: Property; Casualty; Health",
      "number": "3000000360"
    },
    {
      "state": "Maine",
      "type": "Non-Resident Producer Business Entity",
      "number": "AGN266095"
    },
    {
      "state": "Michigan",
      "type": "Non-Resident Producer: Accident and Health; Casualty; Property",
      "number": "109309"
    },
    {
      "state": "Minnesota",
      "type": "Business Producer",
      "number": "40470165"
    },
    {
      "state": "Mississippi",
      "type": "Insurance Producer Entity",
      "number": "15028914"
    },
    {
      "state": "Montana",
      "type": "Producer: Property; Casualty; Disability (Health)",
      "number": "100150539"
    },
    {
      "state": "North Carolina",
      "type": "Corporation",
      "number": "352533139"
    },
    {
      "state": "North Dakota",
      "type": "Producer: Accident & Health; Property; Casualty",
      "number": "2000155276"
    },
    {
      "state": "Nebraska",
      "type": "Agency",
      "number": "100248798"
    },
    {
      "state": "New Hampshire",
      "type": "Producer: Property & Casualty; Accident & Health",
      "number": "2339201"
    },
    {
      "state": "New Jersey",
      "type": "Producer - Organization (Corp): Property; Accident Health or Sickness; Casualty; Personal Lines",
      "number": "1607201"
    },
    {
      "state": "New Mexico",
      "type": "Firm: Accident & Health; Vehicle; Property, Marine, and Transportation; Casualty & Surety",
      "number": "100014026"
    },
    {
      "state": "Nevada",
      "type": "Non-Resident Producer Firm: Casualty; Health; Property",
      "number": "3154497"
    },
    {
      "state": "New York",
      "type": "Broker: Life; Accident & Health; Property; Casualty; Personal Lines",
      "number": "1400283"
    },
    {
      "state": "Ohio",
      "type": "Major Lines: Accident & Health; Property; Casualty",
      "number": "1101247"
    },
    {
      "state": "Oklahoma",
      "type": "Producer: Accident & Health; Property; Casualty",
      "number": "100253886"
    },
    {
      "state": "Pennsylvania",
      "type": "Nonresident Producer Agency: Accident & Health; Casualty & Allied Lines; Property & Allied Lines",
      "number": "771128"
    },
    {
      "state": "South Carolina",
      "type": "Agency",
      "number": "207676"
    },
    {
      "state": "South Dakota",
      "type": "Business Entity",
      "number": "10018823"
    },
    {
      "state": "Tennessee",
      "type": "Business Entity Producer",
      "number": "2330576"
    },
    {
      "state": "Utah",
      "type": "Non-Resident Producer: Accident & Health; Property; Casualty",
      "number": "567110"
    },
    {
      "state": "Virginia",
      "type": "Producer: Health; Property & Casualty",
      "number": "139662"
    },
    {
      "state": "Vermont",
      "type": "Non-Resident Producer Business Entity",
      "number": "3146973"
    },
    {
      "state": "Wyoming",
      "type": "Non-Resident Producer Firm: Accident & Health; Property; Casualty",
      "number": "309108"
    }
  ],
  "personal": [
    {
      "name": "Wayne Slavin",
      "rows": [
        {
          "state": "Alabama",
          "type": "Producer: Accident & Health or Sickness; Property; Casualty; Life",
          "number": "750533"
        },
        {
          "state": "Alaska",
          "type": "Producer: Life; Health; Property; Casualty",
          "number": "100128084"
        },
        {
          "state": "Arizona",
          "type": "Insurance Professional: Accident, Health & Sickness; Property; Casualty; Life",
          "number": "1137084"
        },
        {
          "state": "Arkansas",
          "type": "Producer: Accident, Health & Sickness; Property; Casualty; Life",
          "number": "17591919"
        },
        {
          "state": "California",
          "type": "Resident Insurance Producer: Accident & Health; Property; Casualty; Life",
          "number": "0K25232"
        },
        {
          "state": "Colorado",
          "type": "Producer: Accident & Health; Property; Casualty; Life",
          "number": "499504"
        },
        {
          "state": "Connecticut",
          "type": "Producer: Life; Accident & Health; Property; Casualty; Credit Products; Travel Accident & Baggage",
          "number": "2514692"
        },
        {
          "state": "Delaware",
          "type": "Producer: Life; Health; Property; Casualty",
          "number": "1399375"
        },
        {
          "state": "Hawaii",
          "type": "Producer: Accident & Health or Sickness; Casualty; Life; Vehicle; Property; Surety; Marine",
          "number": "436240"
        },
        {
          "state": "Idaho",
          "type": "Non-Resident Producer: Disability (Health); Casualty; Life; Property",
          "number": "559849"
        },
        {
          "state": "Illinois",
          "type": "Producer: Life; Health; Property; Casualty",
          "number": "17591919"
        },
        {
          "state": "Indiana",
          "type": "Producer: Life, Accident & Health; Property & Casualty",
          "number": "3135504"
        },
        {
          "state": "Iowa",
          "type": "Producer: Accident & Health; Property; Casualty; Life",
          "number": "17591919"
        },
        {
          "state": "Kansas",
          "type": "Agent: Life; Health; Property; Casualty; Crop; Personal Lines",
          "number": "17591919"
        },
        {
          "state": "Kentucky",
          "type": "Agent: Health; Property; Casualty; Life",
          "number": "904756"
        },
        {
          "state": "Louisiana",
          "type": "Producer: Accident & Health; Property; Casualty; Life",
          "number": "682837"
        },
        {
          "state": "Maine",
          "type": "Non-Resident Producer: Life and Health; Property and Casualty",
          "number": "PRN263357"
        },
        {
          "state": "Maryland",
          "type": "Producer: Casualty; Property; Health; Life",
          "number": "2188965"
        },
        {
          "state": "Massachusetts",
          "type": "Individual Producer: Accident & Health or Sickness; Property; Casualty; Life",
          "number": "1996897"
        },
        {
          "state": "Michigan",
          "type": "Non-Resident Producer: Accident & Health; Property; Casualty; Life",
          "number": "756261"
        },
        {
          "state": "Minnesota",
          "type": "Producer: Accident & Health; Property; Casualty; Life",
          "number": "40462894"
        },
        {
          "state": "Mississippi",
          "type": "Insurance Producer: Accident & Health; Property; Casualty; Life",
          "number": "10418819"
        },
        {
          "state": "Missouri",
          "type": "Producer: Accident & Health; Property; Casualty; Life",
          "number": "8368979"
        },
        {
          "state": "Montana",
          "type": "Producer: Life; Casualty; Property; Disability (Health)",
          "number": "100148154"
        },
        {
          "state": "Nebraska",
          "type": "Producer: Life and Annuities; Sickness, Accident & Health; Property; Casualty",
          "number": "17591919"
        },
        {
          "state": "Nevada",
          "type": "Non-Resident Producer: Health; Property; Casualty; Life",
          "number": "3135083"
        },
        {
          "state": "New Hampshire",
          "type": "Producer: Accident & Health; Property; Casualty; Life",
          "number": "2335096"
        },
        {
          "state": "New Jersey",
          "type": "Producer: Life; Personal Lines; Casualty; Property; Accident Health or Sickness",
          "number": "1602394"
        },
        {
          "state": "New Mexico",
          "type": "Agent: Life, Accident & Health; Casualty & Surety; Property, Marine, and Transportation; Vehicle",
          "number": "412333"
        },
        {
          "state": "New York",
          "type": "Broker: Accident & Health; Property; Casualty; Life",
          "number": "1384887"
        },
        {
          "state": "North Carolina",
          "type": "Producer: Accident & Health or Sickness; Property; Casualty; Life",
          "number": "17591919"
        },
        {
          "state": "North Dakota",
          "type": "Producer: Accident & Health; Property; Casualty; Life & Annuity",
          "number": "17591919"
        },
        {
          "state": "Ohio",
          "type": "Major Lines: Accident & Health; Property; Casualty; Life",
          "number": "1094088"
        },
        {
          "state": "Oklahoma",
          "type": "Producer: Accident & Health; Property; Casualty; Life",
          "number": "100248504"
        },
        {
          "state": "Oregon",
          "type": "Producer: Health; Property; Casualty; Life",
          "number": "17591919"
        },
        {
          "state": "Pennsylvania",
          "type": "Non-Resident Producer: Accident & Health; Property & Allied Lines; Life & Fixed Annuities; Casualty & Allied Lines",
          "number": "764795"
        },
        {
          "state": "South Carolina",
          "type": "Producer: Accident & Health; Property; Casualty; Life",
          "number": "802327"
        },
        {
          "state": "South Dakota",
          "type": "Non-Resident Producer: Accident & Health or Sickness; Property; Casualty; Life",
          "number": "40410939"
        },
        {
          "state": "Tennessee",
          "type": "Producer: Accident & Health; Property; Casualty; Life",
          "number": "2325709"
        },
        {
          "state": "Texas",
          "type": "General Lines Agent: Life, Accident, Health and HMO; Property & Casualty",
          "number": "2067498"
        },
        {
          "state": "Utah",
          "type": "Non-Resident Producer: Accident & Health; Property; Casualty; Life",
          "number": "559801"
        },
        {
          "state": "Vermont",
          "type": "Non-Resident Producer: Accident & Health; Property; Casualty; Life",
          "number": "3135392"
        },
        {
          "state": "Virginia",
          "type": "Producer: Property & Casualty; Life & Annuities; Health",
          "number": "980150"
        },
        {
          "state": "Washington",
          "type": "Producer: Casualty",
          "number": "910887"
        },
        {
          "state": "Wisconsin",
          "type": "Intermediary (Agent): Accident & Health; Property; Casualty; Life",
          "number": "17591919"
        },
        {
          "state": "Wyoming",
          "type": "Non-Resident Producer: Accident & Health; Property; Casualty; Life",
          "number": "305580"
        },
        {
          "state": "District of Columbia",
          "type": "Producer: Life; Accident & Health or Sickness; Property; Casualty; Personal Lines",
          "number": "3087908"
        }
      ]
    }
  ]
};

export default LICENSES;
